{
    "AppMenu_AppsTitle": "Menu",
    "AppMenu_Apps_Reporting": "Analyses",
    "AppMenu_Apps_FastProvisioning": "Snelle provisioning",
    "AppMenu_Apps_Administration": "Administratie",
    "AppMenu_Apps_StatusAndTools": "Status en hulpmiddelen",
    "AppMenu_FavouritesTitle": "Favorieten",
    "NAME": "AppMenu",
    "AppMenu_NewUI": "CX Suite",
    "AppMenu_ClassicUI": "Klassieke look",
    "AppMenu_NewUIBadge": "Nieuw",
    "AppMenu_NewUIInvite_AriaLabel": "Probeer CX Suite.",
    "AppMenu_NewUIInvite_Heading": "Bekijk CX Suite",
    "AppMenu_NewUIInvite_Body": "Een snellere startpagina, ruimere rapporten en een duidelijkere navigatie. Probeer het eens – u kunt op elk moment terugschakelen.",
    "AppMenu_NewUIInvite_Confirm": "Bekijk het eens",
    "AppMenu_NewUIInvite_Dismiss": "Nu niet"
}